<template>
  <div class="skeleton-workspace-history">
    <fts-skeleton size="35px" avatar class="skel-workspace-history-avatar" />
    <div class="skel-workspace-history-info">
      <fts-skeleton height="18px" width="70%" class="skel-workspace-history-row-alpha" />
      <fts-skeleton height="14px" width="35%" />
    </div>
  </div>
</template>

<script>
import FTSSkeleton from "../FTSSkeletonScreen";

export default {
  components: {
    "fts-skeleton": FTSSkeleton,
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.skeleton-workspace-history {
  display: flex;
  align-items: flex-start;
  .skel-workspace-history-avatar {
    margin-right: .375rem;
  }
  .skel-workspace-history-info {
    flex: 1;
    .skel-workspace-history-row-alpha {
      margin-bottom: .475rem;
    }
  }
}
</style>